import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Define the shape of the state
export interface AppointmentState {
  data: any; // Replace `any` with a more specific type if possible
}

// Define the initial state
const initialState: AppointmentState = {
  data: null,
};

// Define the slice
const appointmentDataSlice = createSlice({
  name: 'appointmentSlice',
  initialState,
  reducers: {
    registerAppointment: (state, action: PayloadAction<any>) => {
      // Replace `any` with a more specific type if possible
      state.data = action.payload;
    },
  },
});

// Export the action creators and the reducer
export const { registerAppointment } = appointmentDataSlice.actions;
export default appointmentDataSlice.reducer;
